'use strict'

function getValueById(id){
    return $(`#${id}`).val();
}

function getValueByName(name){
    return $(`[name="${name}"]`).val();
}

function setTextById(id,value){
    console.log("value: " + value);
     if(value != null || value != "" || value != undefined){
        return $(`#${id}`).text(value);
     }
     return $(`#${id}`).text("-");
}

function beforeLoadingButton(el, val=null) {
    if(val ==null) {
        el.html('<div class="d-flex justify-content-center align-items-center"><span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span> Loading...</div>');
    } else {
        el.html(`<div class="d-flex justify-content-center align-items-center"><span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span> ${val}</div>`);
    }
    el.addClass('disabled');
    el.prop('disabled', true);
}

function afterLoadingButton(el, val=null){
    if(val ==null) {
        el.html('Save');
    } else {
        el.html(val);
    }
    el.removeClass('disabled');
    el.prop('disabled', false);
}

function showMessage(status,title,message){
    Swal.fire(
        title,
        message,
        status
    );
}

// HTTP REQUEST
async function postData(url = '', data = {}) {
    return await axios.post(url, data)
}

async function deleteData(url = '', data = {}) {
    return await axios.delete(url, data)
}

async function updateData(url = '', id, data = {}) {
    return await axios.post(url, id, data)
}

async function putData(url = '', data = {}) {
    return await axios.put(url, data)
}

async function getData(url, id) {
    return await axios.get(url, id)
}

async function getResult(url,params) {
    return await axios.get(url,{params: params})
}

async function getRegion(url = '', data = {}) {
    return await axios.get(url, {params: data})
}

/* Date Time Fuction */

function convertDateTimeId(input){
    let date = new Date(input);
    if(input != new Date())
        date = new Date(input);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const day = String(date.getDate()).padStart(2, '0'); 
    const result = year + "-" + month + "-" + day;
    return result;
}